import { useMemo } from 'react';

import type { DocNode } from '@atlaskit/adf-schema';
import { reduce } from '@atlaskit/adf-utils/traverse';

import { fg } from '@confluence/feature-gating';

export type AdfStats = {
	totalNodeCount: number;
	nodeCountByType: Record<string, number>;
};

type UseAdfStatsProps = { adfDocument: DocNode };

export const useAdfStats = ({ adfDocument }: UseAdfStatsProps): AdfStats => {
	return useMemo(() => {
		if (fg('cc_complexit_fe_progressive_rendering_condition')) {
			let totalNodeCount = 0;
			const nodeCountByType = reduce<Record<string, number>>(
				adfDocument,
				(acc, node) => {
					acc[node.type] = (acc[node.type] || 0) + 1;
					totalNodeCount++;
					return acc;
				},
				{},
			);

			return {
				totalNodeCount,
				nodeCountByType,
			};
		} else {
			return {
				totalNodeCount: 0,
				nodeCountByType: {},
			};
		}
	}, [adfDocument]);
};
